 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0007 from '@/components/content/content-0007'
 import CONTENTCONTENT0009 from '@/components/content/content-0009'
 import CONTENTCONTENT0014 from '@/components/content/content-0014'
 import CONTENTCONTENT0020 from '@/components/content/content-0020'
 import CONTENTCONTENT0023 from '@/components/content/content-0023'
 import CONTENTCONTENT0028 from '@/components/content/content-0028'
 import CONTENTCONTENT0034 from '@/components/content/content-0034'
 import CONTENTCONTENT0037 from '@/components/content/content-0037'
 import CONTENTCONTENT0040 from '@/components/content/content-0040'
 import CONTENTCONTENT0044 from '@/components/content/content-0044'
 import CONTENTCONTENT0047 from '@/components/content/content-0047'
 import CONTENTCONTENT0051 from '@/components/content/content-0051'
 import CONTENTCONTENT0053 from '@/components/content/content-0053'
 import CONTENTCONTENT0061 from '@/components/content/content-0061'
 import CONTENTCONTENT0063 from '@/components/content/content-0063'
 import CONTENTCONTENT0070 from '@/components/content/content-0070'
 import CONTENTCONTENT0072 from '@/components/content/content-0072'
 import CONTENTCONTENT0083 from '@/components/content/content-0083'
 import CONTENTCONTENT0092 from '@/components/content/content-0092'
 import CONTENTCONTENT0099 from '@/components/content/content-0099'
 import CONTENTCONTENT0106 from '@/components/content/content-0106'
 import CONTENTCONTENT0109 from '@/components/content/content-0109'
 import CONTENTCONTENT0111 from '@/components/content/content-0111'
 import CONTENTCONTENT0118 from '@/components/content/content-0118'
 import CONTENTCONTENT0124 from '@/components/content/content-0124'
 import CONTENTCONTENT0127 from '@/components/content/content-0127'
 import CONTENTCONTENT0132 from '@/components/content/content-0132'
 import CONTENTCONTENT0141 from '@/components/content/content-0141'
 import CONTENTCONTENT0145 from '@/components/content/content-0145'
 import CONTENTCONTENT0150 from '@/components/content/content-0150'
 import CONTENTCONTENT0156 from '@/components/content/content-0156'
 import CONTENTCONTENT0159 from '@/components/content/content-0159'
 import CONTENTCONTENT0161 from '@/components/content/content-0161'
 import CONTENTCONTENT0164 from '@/components/content/content-0164'
 import CONTENTCONTENT0166 from '@/components/content/content-0166'
 import CONTENTCONTENT0171 from '@/components/content/content-0171'
 import CONTENTCONTENT0173 from '@/components/content/content-0173'
 import CONTENTCONTENT0187 from '@/components/content/content-0187'
 import CONTENTCONTENT0197 from '@/components/content/content-0197'
 import CONTENTCONTENT0200 from '@/components/content/content-0200'
 import CONTENTCONTENT0202 from '@/components/content/content-0202'
 import CONTENTCONTENT0211 from '@/components/content/content-0211'
 import CONTENTCONTENT0216 from '@/components/content/content-0216'
 import CONTENTCONTENT0220 from '@/components/content/content-0220'
 import CONTENTCONTENT0226 from '@/components/content/content-0226'
 import CONTENTCONTENT0233 from '@/components/content/content-0233'
 import CONTENTCONTENT0241 from '@/components/content/content-0241'
 import CONTENTCONTENT0245 from '@/components/content/content-0245'
 import CONTENTCONTENT0247 from '@/components/content/content-0247'
 import CONTENTCONTENT0251 from '@/components/content/content-0251'
 import CONTENTCONTENT0254 from '@/components/content/content-0254'
 import CONTENTCONTENT0257 from '@/components/content/content-0257'
 import CONTENTCONTENT0262 from '@/components/content/content-0262'
 import CONTENTCONTENT0270 from '@/components/content/content-0270'
 import CONTENTCONTENT0282 from '@/components/content/content-0282'
 import CONTENTCONTENT0284 from '@/components/content/content-0284'
 import CONTENTCONTENT0289 from '@/components/content/content-0289'
 import CONTENTCONTENT0299 from '@/components/content/content-0299'
 import CONTENTCONTENT0310 from '@/components/content/content-0310'
 import CONTENTCONTENT0314 from '@/components/content/content-0314'
 import CONTENTCONTENT0316 from '@/components/content/content-0316'
 import CONTENTCONTENT0319 from '@/components/content/content-0319'
 import CONTENTCONTENT0327 from '@/components/content/content-0327'
 import CONTENTCONTENT0329 from '@/components/content/content-0329'
 import CONTENTCONTENT0337 from '@/components/content/content-0337'
 import CONTENTCONTENT0339 from '@/components/content/content-0339'
 import CONTENTCONTENT0343 from '@/components/content/content-0343'
 import CONTENTCONTENT0352 from '@/components/content/content-0352'
 import CONTENTCONTENT0359 from '@/components/content/content-0359'
 import CONTENTCONTENT0361 from '@/components/content/content-0361'
 import CONTENTCONTENT0363 from '@/components/content/content-0363'
 import CONTENTCONTENT0365 from '@/components/content/content-0365'
 import CONTENTCONTENT0370 from '@/components/content/content-0370'
 import CONTENTCONTENT0376 from '@/components/content/content-0376'
 import CONTENTCONTENT0381 from '@/components/content/content-0381'
 import CONTENTCONTENT0388 from '@/components/content/content-0388'
 import CONTENTCONTENT0390 from '@/components/content/content-0390'
 import CONTENTCONTENT0395 from '@/components/content/content-0395'
 import CONTENTCONTENT0400 from '@/components/content/content-0400'
 import CONTENTCONTENT0405 from '@/components/content/content-0405'
 import CONTENTCONTENT0407 from '@/components/content/content-0407'
 import CONTENTCONTENT0413 from '@/components/content/content-0413'
 import CONTENTCONTENT0415 from '@/components/content/content-0415'
 import CONTENTCONTENT0423 from '@/components/content/content-0423'
 import CONTENTCONTENT0426 from '@/components/content/content-0426'
 import CONTENTCONTENT0428 from '@/components/content/content-0428'
 import CONTENTCONTENT0432 from '@/components/content/content-0432'
 import CONTENTCONTENT0439 from '@/components/content/content-0439'
 import CONTENTCONTENT0446 from '@/components/content/content-0446'
 import CONTENTCONTENT0452 from '@/components/content/content-0452'
 import CONTENTCONTENT0460 from '@/components/content/content-0460'
 import CONTENTCONTENT0462 from '@/components/content/content-0462'
 import CONTENTCONTENT0465 from '@/components/content/content-0465'
 import CONTENTCONTENT0470 from '@/components/content/content-0470'
 import CONTENTCONTENT0479 from '@/components/content/content-0479'
 import CONTENTCONTENT0487 from '@/components/content/content-0487'
 import CONTENTCONTENT0493 from '@/components/content/content-0493'
 import CONTENTCONTENT0495 from '@/components/content/content-0495'
 import CONTENTCONTENT0497 from '@/components/content/content-0497'
 import CONTENTCONTENT0504 from '@/components/content/content-0504'
 import CONTENTCONTENT0508 from '@/components/content/content-0508'
 import CONTENTCONTENT0511 from '@/components/content/content-0511'
 import CONTENTCONTENT0515 from '@/components/content/content-0515'
 import CONTENTCONTENT0518 from '@/components/content/content-0518'
 import CONTENTCONTENT0525 from '@/components/content/content-0525'
 import CONTENTCONTENT0527 from '@/components/content/content-0527'
 import CONTENTCONTENT0529 from '@/components/content/content-0529'
 import CONTENTCONTENT0532 from '@/components/content/content-0532'
 import CONTENTCONTENT0535 from '@/components/content/content-0535'
 import CONTENTCONTENT0540 from '@/components/content/content-0540'
 import CONTENTCONTENT0547 from '@/components/content/content-0547'
 import CONTENTCONTENT0553 from '@/components/content/content-0553'
 import CONTENTCONTENT0559 from '@/components/content/content-0559'
 import CONTENTCONTENT0563 from '@/components/content/content-0563'
 import CONTENTCONTENT0567 from '@/components/content/content-0567'
 import CONTENTCONTENT0574 from '@/components/content/content-0574'
 import CONTENTCONTENT0581 from '@/components/content/content-0581'
 import CONTENTCONTENT0588 from '@/components/content/content-0588'
 import CONTENTCONTENT0593 from '@/components/content/content-0593'
 import CONTENTCONTENT0599 from '@/components/content/content-0599'
 import CONTENTCONTENT0601 from '@/components/content/content-0601'
 import CONTENTCONTENT0607 from '@/components/content/content-0607'
 import CONTENTCONTENT0613 from '@/components/content/content-0613'
 import CONTENTCONTENT0620 from '@/components/content/content-0620'
 import CONTENTCONTENT0627 from '@/components/content/content-0627'
 import CONTENTCONTENT0636 from '@/components/content/content-0636'
 import CONTENTCONTENT0640 from '@/components/content/content-0640'
 import CONTENTCONTENT0643 from '@/components/content/content-0643'
 import CONTENTCONTENT0648 from '@/components/content/content-0648'
 import CONTENTCONTENT0652 from '@/components/content/content-0652'
 import CONTENTCONTENT0657 from '@/components/content/content-0657'
 import CONTENTCONTENT0665 from '@/components/content/content-0665'
 import CONTENTCONTENT0668 from '@/components/content/content-0668'
 import CONTENTCONTENT0672 from '@/components/content/content-0672'
 import CONTENTCONTENT0676 from '@/components/content/content-0676'
 import CONTENTCONTENT0683 from '@/components/content/content-0683'
 import CONTENTCONTENT0691 from '@/components/content/content-0691'
 import CONTENTCONTENT0697 from '@/components/content/content-0697'
 import CONTENTCONTENT0703 from '@/components/content/content-0703'
 import CONTENTCONTENT0707 from '@/components/content/content-0707'
 import CONTENTCONTENT0714 from '@/components/content/content-0714'
 import CONTENTCONTENT0723 from '@/components/content/content-0723'
 import CONTENTCONTENT0727 from '@/components/content/content-0727'
 import CONTENTCONTENT0735 from '@/components/content/content-0735'
 import CONTENTCONTENT0740 from '@/components/content/content-0740'
 import CONTENTCONTENT0745 from '@/components/content/content-0745'
 import CONTENTCONTENT0753 from '@/components/content/content-0753'
 import CONTENTCONTENT0756 from '@/components/content/content-0756'
 import CONTENTCONTENT0759 from '@/components/content/content-0759'
 import CONTENTCONTENT0763 from '@/components/content/content-0763'
 import CONTENTCONTENT0764 from '@/components/content/content-0764'
 import CONTENTCONTENT0765 from '@/components/content/content-0765'
 import CONTENTCONTENT0768 from '@/components/content/content-0768'
 import CONTENTCONTENT0776 from '@/components/content/content-0776'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content-0007",
 			"name" : "content/content-0007",
 			"component" : CONTENTCONTENT0007
 		},
 		{
 			"path" : "/content/content-0009",
 			"name" : "content/content-0009",
 			"component" : CONTENTCONTENT0009
 		},
 		{
 			"path" : "/content/content-0014",
 			"name" : "content/content-0014",
 			"component" : CONTENTCONTENT0014
 		},
 		{
 			"path" : "/content/content-0020",
 			"name" : "content/content-0020",
 			"component" : CONTENTCONTENT0020
 		},
 		{
 			"path" : "/content/content-0023",
 			"name" : "content/content-0023",
 			"component" : CONTENTCONTENT0023
 		},
 		{
 			"path" : "/content/content-0028",
 			"name" : "content/content-0028",
 			"component" : CONTENTCONTENT0028
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js